import { render, staticRenderFns } from "./OverviewAmerta.vue?vue&type=template&id=8db0da32"
import script from "./OverviewAmerta.vue?vue&type=script&lang=js"
export * from "./OverviewAmerta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports